export default "__VITE_ASSET__DcjxAeyc__"